import { useTimelineView, TimelineViewMode } from '../../../features/timeline-navigation'
import { useTimelineDay } from '../model/useTimelineDay'
import { useTimelineWeek } from '../model/useTimelineWeek'

const ArrowLeft = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="34" height="34" rx="17" fill="white" />
    <rect x="0.5" y="0.5" width="34" height="34" rx="17" stroke="#004494" />
    <path d="M12 17.5L20.25 10.1388L20.25 24.8612L12 17.5Z" fill="#004494" />
  </svg>
)

const ArrowRight = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="34" height="34" rx="17" fill="white" />
    <rect x="0.5" y="0.5" width="34" height="34" rx="17" stroke="#004494" />
    <path d="M23 17.5L14.75 24.8612L14.75 10.1388L23 17.5Z" fill="#004494" />
  </svg>
)

const ViewToggle = ({ view, onChange }: { view: TimelineViewMode; onChange: (v: TimelineViewMode) => void }) => (
  <div className="flex rounded-lg overflow-hidden border border-[#004494]">
    <button
      type="button"
      className={`px-3 py-1.5 text-sm font-medium transition-colors ${
        view === 'day' ? 'bg-[#004494] text-white' : 'bg-white text-[#004494] hover:bg-blue-50'
      }`}
      onClick={() => onChange('day')}
    >
      Tag
    </button>
    <button
      type="button"
      className={`px-3 py-1.5 text-sm font-medium transition-colors ${
        view === 'week' ? 'bg-[#004494] text-white' : 'bg-white text-[#004494] hover:bg-blue-50'
      }`}
      onClick={() => onChange('week')}
    >
      Woche
    </button>
  </div>
)

export const TimelineNav = () => {
  const { view, setView } = useTimelineView()
  const dayHook = useTimelineDay()
  const weekHook = useTimelineWeek()

  const label = view === 'day' ? dayHook.formattedLabel : weekHook.formattedLabel
  const onPrev = view === 'day' ? dayHook.goToPrevDay : weekHook.goToPrevWeek
  const onNext = view === 'day' ? dayHook.goToNextDay : weekHook.goToNextWeek

  return (
    <div className="flex items-center gap-4">
      <div className="flex flex-row gap-[10px] items-center">
        <button type="button" onClick={onPrev} className="focus:outline-none">
          <ArrowLeft />
        </button>
        <div className='w-[200px] text-center'>{label}</div>
        <button type="button" onClick={onNext} className="focus:outline-none">
          <ArrowRight />
        </button>
      </div>
      <ViewToggle view={view} onChange={setView} />
    </div>
  )
}
